{
    "name": "Cremini Mushroom",
    "binomial_name": "Agaricus bisporus",
    "common_names": [
        "Cremini mushroom",
        "cremini"
    ],
    "description": "Cremini mushroom are the same species (Agaricus bisporus) as White Button and Portobello mushrooms. White Button are harvested earliest, making them the youngest version of the mushroom. Portobello are the most mature version of the mushroom, making Cremini the adolescent stage. Cremini have a browner color, denser texture, and deeper flavor than White Button. They hold up better in stews and soups than White Buttons. Growing Agaricus bisporus requires spores and partially decomposed compost and peat moss. These mushrooms can be grown indoors year-round because temperature, moisture, and light can be controlled. They can also be grown outdoors.",
    "sun_requirements": "Full Shade",
    "sowing_method": "Sprinkle spores on surface of compost and peat moss, gently mix in, and press down.",
    "spread": 0,
    "row_spacing": 0,
    "height": 0,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/cremini-mushroom.jpg",
    "icon": "/crops/icons/cremini-mushroom.avif"
}